<template>
  <div class="overflow-x-scroll overflow-y-visible" >
    <table class="w-full border-collapse border border-gray-300 text-sm">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="border border-gray-300 p-2">Ngày <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Diễn giải <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">ĐVT <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Số lượng <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Đơn giá <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Số tiền <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Ghi chú</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in localValue" :key="index">
          <!-- Ngày -->
          <td class="border border-gray-300 p-2">
            <input type="date" v-model="item.date"
              class="w-full border rounded p-1 text-sm focus:border-blue-500 focus:outline-none" />
          </td>

          <!-- Diễn giải + search -->
          <td class="border border-gray-300 p-2 relative">
            <div class="search-box relative">
              <input
                type="text"
                v-model="item.detail"
                @input="searchProduct(item)"
                placeholder="Nhập tên hoặc mã sản phẩm..."
                class="w-[160px] border rounded p-1 text-sm focus:border-blue-500 focus:outline-none"
              />

              <!-- Danh sách gợi ý -->
              <ul
                v-if="item.showSuggestions && item.results?.length"
                class="absolute bg-white border border-gray-300 w-full max-h-40 overflow-auto z-50 text-left"
              >
                <li
                  v-for="product in item.results"
                  :key="product.id"
                  @click="selectProduct(item, product)"
                  class="p-2 hover:bg-gray-100 cursor-pointer"
                >
                  {{ product.name }} ({{ product.code }})
                </li>
              </ul>
            </div>
          </td>

          <!-- ĐVT -->
          <td class="border border-gray-300 p-2 text-center">
            <input v-model="item.unit"
              class="w-[60px] border rounded p-1 text-sm focus:border-blue-500 focus:outline-none" />
          </td>

          <!-- Số lượng -->
          <td class="border border-gray-300 p-2 text-center">
            <input data-key="quantity" v-model.number="item.quantity" min="0" @input="updateQuantityItem($event,item)" @keypress="onlyNumberAndDot($event)"
              class="w-[80px] border rounded p-1 text-sm text-right focus:border-blue-500 focus:outline-none" />
          </td>

          <!-- Đơn giá -->
          <td class="border border-gray-300 p-2 text-center">
            <input data-key="price" :value="formatNumber(item.price)" min="0" @input="updateMoneyItem($event,item)" @keypress="onlyNumber"
              class="w-[120px] border rounded p-1 text-sm text-right focus:border-blue-500 focus:outline-none" />
          </td>

          <!-- Số tiền -->
          <td class="border border-gray-300 p-2 text-center">
            <!-- Disabled (readonly) input hiển thị tiền đã tính, không cho sửa trực tiếp -->
            <input :value="formatNumber(Math.floor(item.money))" 
              class="w-[120px] border rounded p-1 text-sm text-right focus:border-blue-500 focus:outline-none"
              disabled />
          </td>

          <!-- Ghi chú -->
          <td class="border border-gray-300 p-2">
            <div class="flex flex-row">
              <textarea v-model="item.note"
                class="w-[180px] border rounded p-1 text-sm focus:border-blue-500 focus:outline-none" />
              <button
                v-if="localValue.length > 1"
                @click="removeProduct(index)"
                class="text-red-500 font-bold text-xs ml-[10px]"
              >
                <font-awesome-icon :icon="['fas', 'trash-can']" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Nút thêm -->
    <div class="mt-3 pb-[120px]">
      <button @click="addProduct" class="text-sm text-blue-500 font-bold">+ Thêm sản phẩm</button>
    </div>
  </div>
</template>

<script>
import { onlyNumber, formatNumber, unformatNumber } from '@/utils/onlyNum';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  props: {
    value: { type: Array, required: true },
    productsItem: { type: Array, default: () => [] }
  },
  computed: {
    localValue: {
      get() { return this.value },
      set(val) { this.$emit("input", val) }
    }
  },
  data() {
    return {
      timeout: null
    };
  },
  mounted() {
    // emit initial total để parent có giá trị ngay khi component mounted
    this.emitTotalUpdate();
  },
  watch: {
    // theo dõi deep thay đổi trong localValue để cập nhật tổng tự động
    localValue: {
      handler() {
        this.emitTotalUpdate();
      },
      deep: true
    }
  },
  methods: {
    onlyNumber,
    formatNumber,

    onlyNumberAndDot(e) {
    const char = String.fromCharCode(e.charCode);
    const allowed = "0123456789."; // chỉ cho phép số và dấu chấm
    if (!allowed.includes(char)) {
      e.preventDefault(); // chặn ký tự
    }
  },

    updateQuantityItem(e, item) {
      const key = e.target.dataset.key;
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '');
      const firstDotIndex = value.indexOf('.');
      if (firstDotIndex !== -1) {
        value = value
          .split('')
          .map((c, i) => (c === '.' && i !== firstDotIndex ? '' : c))
          .join('');
      }
      item[key] = parseFloat(value) || 0;
      item.money = (item.quantity || 0) * (item.price || 0);
      e.target.value = value;
    },

    // ✅ Tìm kiếm sản phẩm từ danh sách FE
    searchProduct(item) {
      const keyword = (item.detail || "").toLowerCase().trim();
      if (!keyword) {
        item.results = [];
        item.showSuggestions = false;
        return;
      }

      const filtered = this.productsItem.filter(
        p =>
          (p.name && p.name.toLowerCase().includes(keyword)) ||
          (p.code && p.code.toLowerCase().includes(keyword))
      );

      item.results = filtered.slice(0, 10);
      item.showSuggestions = !!item.results.length;
    },

    selectProduct(item, product) {
      item.detail = `${product.code} - ${product.name}`;
      item.unit = product.unit || "";
      item.showSuggestions = false;
      item.results = [];
      // nếu cần thay đổi price từ product, bạn có thể gán ở đây rồi gọi updateMoney(item)
      // item.price = product.price || item.price;
      // this.updateMoney(item);
    },

    updateMoneyItem(e ,item) {
      let key = e.target.dataset.key;
      let value = unformatNumber(e.target.value)
      item[key] = value
      item.money = (item.quantity || 0) * (item.price || 0);

      this.emitTotalUpdate();
    },

    formatCurrency(value) {
      if (value === null || value === undefined) return "0";
      // nếu value = 0, vẫn format là "0"
      const num = Number(value) || 0;
      return new Intl.NumberFormat("vi-VN").format(num);
    },

    addProduct() {
      this.localValue.push({
        date: new Date().toISOString().slice(0, 10),
        detail: "",
        unit: "",
        quantity: 0,
        price: 0,
        money: 0,
        note: "",
        showSuggestions: false,
        results: []
      });
      // emit tổng sau khi thêm 1 dòng mới (dòng mới có tiền 0)
      this.emitTotalUpdate();
    },

    removeProduct(index) {
      this.localValue.splice(index, 1);
      // emit tổng sau khi remove
      this.emitTotalUpdate();
    },

    emitTotalUpdate() {
      // 🔧 SỬA: dùng this.localValue thay vì this.products (this.products không tồn tại trong component)
      const total = (this.localValue || []).reduce((sum, item) => {
        const value = Number(item.money) || 0;
        return sum + value;
      }, 0);
      this.$emit("update-total", total);
    },
  }
};
</script>

<style scoped>
.search-box {
  position: relative;
  overflow: visible;
}
</style>
